import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { isArchivedFilter } from './data'

interface PascodeMetadata {
  AdditionalPASCODEsSupported: string
  AssignedComponentCode: number
  Installation: string
  MAJCOM: string
  OrgMAJCOM: string
  Organization: string
  PASCODE: string
  ServicingBy: string
  ServicingMAJCOM: string
  ServicingOrganization: string
}

interface PascodeMetadataFetchArgs {
  IsArchived: false | null | true
  isAscending?: boolean
  orderBy?: string
}

const LIST_NAME = 'PASCODEMetadataList'
const COLUMN_NAMES = {
  AdditionalPASCODEsSupported: 'AdditionalPASCODEsSupported',
  AssignedComponentCode: 'AssignedComponentCode',
  Code: 'Code',
  HostMAJCOM: 'HostMAJCOM',
  HostOrganization: 'HostOrganization',
  Installation: 'Installation',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  OrgMAJCOM: 'OrgMAJCOM',
  Organization: 'Organization',
  PASCODE: 'PASCODE',
  ServicingBy: 'ServicingBy',
  ServicingCSSPASCODE: 'ServicingCSSPASCODE',
  ServicingMAJCOM: 'ServicingMAJCOM',
  ServicingOrganization: 'ServicingOrganization',
}

const getPascodeMetadata = async (
  args: PascodeMetadataFetchArgs
): Promise<PascodeMetadata[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.IsArchived)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ItemModified

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.ServicingCSSPASCODE,
      COLUMN_NAMES.AdditionalPASCODEsSupported,
      COLUMN_NAMES.AssignedComponentCode,
      COLUMN_NAMES.Code,
      COLUMN_NAMES.Installation,
      COLUMN_NAMES.IsArchived, 
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.HostOrganization,
      COLUMN_NAMES.HostMAJCOM,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.OrgMAJCOM,
      COLUMN_NAMES.Organization,
      COLUMN_NAMES.PASCODE,
      COLUMN_NAMES.ServicingBy,
      COLUMN_NAMES.ServicingMAJCOM,
      COLUMN_NAMES.ServicingOrganization,
      'ItemCreatedBy/firstName', 
      'ItemCreatedBy/lastName',
      'ItemModifiedBy/firstName', 
      'ItemModifiedBy/lastName',
      'AssignedComponent/MetadataValue',
      'eKey',
      'eTag')
    .expand('ItemCreatedBy', 'ItemModifiedBy', 'AssignedComponent')
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as PascodeMetadata[]
}

export {
  COLUMN_NAMES,
  LIST_NAME,
  type PascodeMetadata,
  type PascodeMetadataFetchArgs,
  getPascodeMetadata,
}
